import { Euler, Vector3 } from "flavr-math";
import { degToRad, radToDeg } from "flavr-common";
import { ModelControlInput } from "./ModelControlInput/ModelControlInput.component";
import React from "react";
function formatNumberString(str) {
    const decimalIndex = str.indexOf(".");
    if (decimalIndex !== -1) {
        const decimalPart = str.slice(decimalIndex + 1);
        if (decimalPart.length <= 5) {
            return str;
        }
        else {
            str = strToNum(str).toFixed(5); // round to 5 decimal places and convert to string
            while (str[str.length - 1] === "0") {
                str = str.slice(0, -1); // remove trailing zero
            }
            if (str[str.length - 1] === ".") {
                str = str.slice(0, -1); // remove trailing dot
            }
        }
    }
    return str;
}
function strToNum(str) {
    if (str === undefined) {
        return 0;
    }
    const num = parseFloat(str);
    return isNaN(num) ? 0 : num;
}
export function stringCoordinatesToVector3(str) {
    return new Vector3(strToNum(str === null || str === void 0 ? void 0 : str.x), strToNum(str === null || str === void 0 ? void 0 : str.y), strToNum(str === null || str === void 0 ? void 0 : str.z));
}
export function vector3ToStringCoordinates(v3) {
    return {
        x: formatNumberString(v3.x.toString()),
        y: formatNumberString(v3.y.toString()),
        z: formatNumberString(v3.z.toString())
    };
}
export function stringCoordinatesToEuler(str) {
    return new Euler(degToRad(strToNum(str === null || str === void 0 ? void 0 : str.x)), degToRad(strToNum(str === null || str === void 0 ? void 0 : str.y)), degToRad(strToNum(str === null || str === void 0 ? void 0 : str.z)));
}
export function eulerToStringCoordinates(euler) {
    return {
        x: formatNumberString(radToDeg(euler.x).toString()),
        y: formatNumberString(radToDeg(euler.y).toString()),
        z: formatNumberString(radToDeg(euler.z).toString())
    };
}
export function getLinkedScale(dimension, value, prevValues) {
    const otherDim1 = dimension === "x" ? "y" : "x";
    const otherDim2 = dimension === "z" ? "y" : "z";
    const result = { x: "1", y: "1", z: "1" };
    if (value === "0" || value === "") {
        result[dimension] = value;
        result[otherDim1] = "0";
        result[otherDim2] = "0";
    }
    else if (prevValues[dimension] === 0) {
        result[dimension] = value;
        result[otherDim1] = value;
        result[otherDim2] = value;
    }
    else {
        const factor = prevValues[dimension] ? parseFloat(value) / prevValues[dimension] : 1;
        result[dimension] = value;
        result[otherDim1] = formatNumberString((prevValues[otherDim1] * factor).toString());
        result[otherDim2] = formatNumberString((prevValues[otherDim2] * factor).toString());
    }
    return result;
}
export function modifyStringCoordinates(previous, value, defaultValue) {
    var _a, _b, _c, _d, _e, _f;
    return {
        x: value.x !== undefined ? formatNumberString(value.x) : (_b = (_a = previous === null || previous === void 0 ? void 0 : previous.x) !== null && _a !== void 0 ? _a : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.x) !== null && _b !== void 0 ? _b : "0",
        y: value.y !== undefined ? formatNumberString(value.y) : (_d = (_c = previous === null || previous === void 0 ? void 0 : previous.y) !== null && _c !== void 0 ? _c : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.y) !== null && _d !== void 0 ? _d : "0",
        z: value.z !== undefined ? formatNumberString(value.z) : (_f = (_e = previous === null || previous === void 0 ? void 0 : previous.z) !== null && _e !== void 0 ? _e : defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.z) !== null && _f !== void 0 ? _f : "0"
    };
}
export const createXYZInputs = (currentValue, onChangeHandler, options) => {
    return (React.createElement("div", null,
        "X:",
        " ",
        React.createElement(ModelControlInput, { currentValue: currentValue === null || currentValue === void 0 ? void 0 : currentValue.x, defaultValue: options === null || options === void 0 ? void 0 : options.defaultValue, onChangeHandler: (value) => {
                onChangeHandler({ x: value });
            }, useRelativeChanges: options === null || options === void 0 ? void 0 : options.relative, stepSize: options === null || options === void 0 ? void 0 : options.stepSize, disabled: options === null || options === void 0 ? void 0 : options.disabled, tooltip: (options === null || options === void 0 ? void 0 : options.tooltip) ? options.tooltip("x") : undefined, disabledTooltip: options === null || options === void 0 ? void 0 : options.disabledTooltip, tooltipPosition: options === null || options === void 0 ? void 0 : options.tooltipPosition, range: options === null || options === void 0 ? void 0 : options.range }),
        "Y:",
        " ",
        React.createElement(ModelControlInput, { currentValue: currentValue === null || currentValue === void 0 ? void 0 : currentValue.y, defaultValue: options === null || options === void 0 ? void 0 : options.defaultValue, onChangeHandler: (value) => {
                onChangeHandler({ y: value });
            }, useRelativeChanges: options === null || options === void 0 ? void 0 : options.relative, stepSize: options === null || options === void 0 ? void 0 : options.stepSize, disabled: options === null || options === void 0 ? void 0 : options.disabled, tooltip: (options === null || options === void 0 ? void 0 : options.tooltip) ? options.tooltip("y") : undefined, disabledTooltip: options === null || options === void 0 ? void 0 : options.disabledTooltip, tooltipPosition: options === null || options === void 0 ? void 0 : options.tooltipPosition, range: options === null || options === void 0 ? void 0 : options.range }),
        "Z:",
        " ",
        React.createElement(ModelControlInput, { currentValue: currentValue === null || currentValue === void 0 ? void 0 : currentValue.z, defaultValue: options === null || options === void 0 ? void 0 : options.defaultValue, onChangeHandler: (value) => {
                onChangeHandler({ z: value });
            }, useRelativeChanges: options === null || options === void 0 ? void 0 : options.relative, stepSize: options === null || options === void 0 ? void 0 : options.stepSize, disabled: options === null || options === void 0 ? void 0 : options.disabled, tooltip: (options === null || options === void 0 ? void 0 : options.tooltip) ? options.tooltip("z") : undefined, disabledTooltip: options === null || options === void 0 ? void 0 : options.disabledTooltip, tooltipPosition: options === null || options === void 0 ? void 0 : options.tooltipPosition, range: options === null || options === void 0 ? void 0 : options.range })));
};
